"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateDestination = calculateDestination;
exports.default = void 0;
var _geographiclib = _interopRequireDefault(require("geographiclib"));
var _destination = _interopRequireDefault(require("@turf/destination"));
var _config = require("./config");
var _MiscUtils = _interopRequireDefault(require("../MiscUtils"));
var _mapUtilsMisc = require("./mapUtilsMisc");
var _transformDistanceWithOptions = _interopRequireDefault(require("./transformDistanceWithOptions"));
var _UnknownDistanceAlgorithmError = _interopRequireDefault(require("../ErrorClasses/UnknownDistanceAlgorithmError"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
// eslint-disable-next-line import/no-named-as-default

const {
  KILOMETERS,
  METERS
} = _config.UNITS.DISTANCE;
const geod = _geographiclib.default.Geodesic.WGS84;
const formatResponseCoordinates = (coords, roundTo) => {
  if (roundTo === undefined) {
    return coords;
  }
  const [x, y] = coords;
  return [_MiscUtils.default.roundToDigitPlace(x, roundTo), _MiscUtils.default.roundToDigitPlace(y, roundTo)];
};
const verifyOptions = options => {
  const keys = Object.keys(options);
  if (keys.length === 0) {
    return;
  }
  throw new Error(`Unkown options: "${keys.join('", "')}"`);
};
function getGeodDestination(coord, distance, azimuth) {
  // Geod expects lat, lon
  const point = geod.Direct(coord[1], coord[0], azimuth, distance);
  return [point.lon2, point.lat2];
}
function getTurfDestination(coord, distance, azimuth) {
  const destination = (0, _destination.default)(coord, distance, azimuth);
  return destination.geometry.coordinates;
}
function getDestinationFromAlgo(algo, coord, distance, azimuth) {
  switch (algo) {
    case _config.GEO_ALGORITHMS.TURF:
      return getTurfDestination(coord, distance, azimuth);
    case _config.GEO_ALGORITHMS.GEOD:
      return getGeodDestination(coord, distance, azimuth);
    default:
      throw new _UnknownDistanceAlgorithmError.default(`Unkown algorithm "${algo}"`);
  }
}
function getUnitOutputedFromAlgorithm(algo) {
  switch (algo) {
    case _config.GEO_ALGORITHMS.TURF:
      return KILOMETERS;
    case _config.GEO_ALGORITHMS.GEOD:
      return METERS;
    default:
      throw new _UnknownDistanceAlgorithmError.default(`Unkown algorithm "${algo}"`);
  }
}

/**
 *
 * @param {[lon, lat]} coord
 * @param {float} distanceRaw
 * @param {float} azimuth
 * @param {{}} options
 * @returns {[lat, lon]} by default - to change, specify {reverseResponse: false} in @options
 */
function calculateDestination(coord,
// expected to be [lon, lat]
distanceRaw, azimuth) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const {
    algorithm = _config.GEO_ALGORITHMS.GEOD,
    from = _config.UNITS.DISTANCE.FEET,
    roundDistance,
    roundCoords,
    reverseResponse = true,
    ...otherOptions
  } = options;
  const to = getUnitOutputedFromAlgorithm(algorithm);
  verifyOptions(otherOptions);
  const distance = (0, _transformDistanceWithOptions.default)(distanceRaw, {
    from,
    to,
    roundTo: roundDistance,
    ...otherOptions
  });
  const destinationCoords = getDestinationFromAlgo(algorithm, (0, _mapUtilsMisc.formatCoords)(coord), distance, azimuth);
  const coords = formatResponseCoordinates(destinationCoords, roundCoords);
  if (!reverseResponse) {
    return coords;
  }
  return [coords[1], coords[0]];
}
var _default = calculateDestination;
exports.default = _default;